import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
    return (
        <div className="flex flex-col min-h-screen overflow-x-hidden">
            <Header />
            <main className="flex-grow pt-[80px]">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
